import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class SelectableInventoryTable extends Component {
  render(){
    return(
      <div>
        <div className="card">
          <div className="card-header border-0">
            {this.props.smallHeaderSize ?
              <h6 className="mb-0">{this.props.tableTitle}</h6>
              :
              <h4 className="mb-0">{this.props.tableTitle}</h4>
            }
          </div>
          <table className="table table-hover mb-0">
            <thead className="thead-inverse">
              <tr>
                {this.props.readOnly ?
                  null
                :
                  <th>Status</th>
                }
                <th>Inventory</th>
                <th>Item</th>
                <th className="hidden-xxs-down">Qty</th>
                <th className="hidden-xs-down">Pieces</th>
                <th>{this.props.showCostPrice ? 'Production Cost' : 'Price' }</th>
              </tr>
            </thead>
            {this.props.list.length > 0 ?
                <tbody>
                  {this.props.list.map((box, idx) => {
                    return (
                      <tr key={idx} className={box.selected && !this.props.readOnly ? 'bg-color-gray' : ''}>
                        {this.props.readOnly ?
                          null
                        :
                          <td>
                            { (!this.props.isReturn && (box.in_credit_note || (!box.active && box.returned === null))) ||
                              (this.props.isReturn &&
                                (box.in_return || (this.props.inCreditNote && this.props.inCreditNote.includes(box.id)) )) ?

                              <span className={box.in_credit_note ? 'color-warning' : 'color-danger'}>
                                {box.in_credit_note || box.in_return ?
                                  'Returned' : (this.props.inCreditNote && this.props.inCreditNote.includes(box.id)) ?
                                                'Credit Note' : 'Inactive'}
                              </span>
                            :
                              <input className="form-check" type="checkbox" disabled={box.in_credit_note} value={idx} onChange={this.props.onSelect}/>
                            }
                          </td>
                        }
                        <td>
                          <NavLink to={`/inventory/${box.id}/`}>
                            {box.id}
                          </NavLink>
                        </td>
                        <td>{box.item.name}{box.item.is_barcode_item && ((box.brand.brand_name && ` (${box.brand.brand_name})`) || (box.brand &&` (${box.brand})`))}</td>
                        <td className={`hidden-xxs-down ${this.props.errorWeight && "has-danger"}`}>
                          {box.selected && !this.props.readOnly ?
                            <input className="form-control" type="number" value={box.weight} onChange={ (event) => {
                                this.props.updateWeight(event.target.value, idx);
                            }}/>
                          :
                            <span>{box.weight}<span className="ml-05 badge badge-pill badge-info">{box.item.measure_unit}</span></span>
                          }

                        </td>
                        <td className={`hidden-xs-down ${this.props.errorPieces && "has-danger"}`}>
                          {box.selected && !this.props.readOnly ?
                            <input className={`form-control ${this.props.errorPieces && "has-danger"}`} type="number" value={box.number_items} onChange={ (event) => {
                                this.props.updateNumberOfItems(event.target.value, idx);
                            }}/>
                          :
                            <span>{box.number_items}</span>
                          }
                        </td>
                        <td>
                          {box.selected && !this.props.readOnly && this.props.updatePrice ?
                            <input className="form-control" type="number" value={box.price} onChange={ (event) => {
                                this.props.updatePrice(event.target.value, idx);
                            }}/>
                          :
                            <span>{box.price}</span>
                          }
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
            :
              null
            }
          </table>
          {this.props.list.length === 0 ?
            <div className="empty-table">
              <span>{this.props.emptyListMessage || ''}</span>
            </div> : null
          }
        </div>
      </div>
    );
  }
}
